export default __webpack_public_path__ + "static/media/built_in_icons_mobile.bc94be2d.png";